import styled, { css } from 'styled-components';
import { Link as LinkComponent } from 'react-router-dom';
import Button from '@prisjakt/ui-button';
import { layout } from '@prisjakt/ui-base';

const BRAND_LOGO_WIDTH = 88;
const BRAND_LOGO_HEIGHT = 31;

export const RecommendedRetailerExpansion = styled.div(
  props => css`
    color: ${props.theme.text.secondary};
    display: inline-flex;
    flex-direction: column;
  `
);

export const LogoWrapper = styled(LinkComponent)`
  align-self: flex-start;
`;

export const Logo = styled.img`
  margin-top: ${layout.measurements.spacingSmall};
  width: ${BRAND_LOGO_WIDTH}px;
  height: ${BRAND_LOGO_HEIGHT}px;
`;

export const Link = styled(LinkComponent)`
  display: flex;
`;

export const Text = styled.p`
  margin: 0;
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const BrandLink = styled(Button)`
  padding: 0;
  vertical-align: baseline;
`;
